<template>
  <section class="statistics py-6 m:py-8 l:py-12">
    <div class="statistics__container">
      <div class="grid">
        <rotating-headers
          class="statistics__header grid__el--xs-12 grid__el--m-6"
          :headers="$t('headers')" />
        <figures
          class="grid__el--xs-12 grid__el--m-6" />
      </div>
    </div>
  </section>
</template>

<script>
import RotatingHeaders from "@/features/rotating-headers/rotating-headers";
import Figures from "./figures";

export default {
  name: "Statistics",
  components: {
    RotatingHeaders,
    Figures
  },
  i18n: {
    messages: {
      en: {
        headers: ["Be more knowledgeable", "Be more successful", "Be healthier ", "Be a better parent", "Be happier", "Be your best self!"]
      },
      de: {
        headers: ["Mehr Wissen", "Erfolgreicher werden", "Besser erziehen", "Gesünder leben", "Glücklicher leben", "Besser kommunizieren"]
      }
    }
  }

};
</script>

<style lang="scss" scoped>

.statistics {

  &__container {
    padding: 0;
    @include media(min-width, m) {
      @include container;
    }
  }

  &__header {
    padding: $spacing-16;
    @include media (min-width, m) {
      padding: 0;
    }
  }
}

</style>
